var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMktgDeliverShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58 51.91V24.79l27.08 13.56v26.2zM65 51.49L37.92 64.13v-26.2L65 24.38z",
    fill: "#ccc6d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16 18.67v26.31l26.63 13.31V32L3.16 18.66zm1.67-2.2l26.32 13.16 26.3-13.16-26.3-13.15L4.83 16.48zM32.5 58.3l26.63-13.31V18.67L32.5 31.98zM31.15 62L.45 46.65V15.64L31.15.29l30.69 15.35v31.01L31.14 62z",
    fill: "#444"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-mktg--deliver-shadow-04808a32b369d7997e82001f000f772f.svg";
export { SvgIconMktgDeliverShadow as Component };